import React from 'react';
import './hero.css';
import { Label, Video } from '@nooz-optics/nooz-components-lib';
import { BannerProps } from './index';
import { Image } from '../../UI/Media/Image';
import { TextBanner } from './BannerText/bannerText';

export const ImageTextBanner = ({
  label,
  body,
  image,
  video,
  desktopImage,
  buttons,
  badges,
  subLabel,
  hasTrustpilot,
  isTextRight = true,
  shopifyPlaylist,
  textContainerAlignment,
  isVerticallyCenter = false,
}: BannerProps) => {
  const textBannerPlacement = isTextRight.value !== false ? 'right' : 'left';
  return (
    <div
      id='hero-main'
      className='hero-main flex flex-col-reverse md:flex-row w-screen min-h-full justify-center items-center relative'
    >
      {/* IMAGE */}
      <div className='relative md:hidden h-full w-full'>
        {image && (
          <Image objectFit='cover' {...image} height='100%' width='100%' />
        )}
        {video && <Video {...video} height='100%' width='100%' />}
      </div>
      {/* VIDEO */}
      <div className='hidden absolute border-t border-b md:block h-full w-full'>
        {video && <Video {...video} height='100%' width='100%' />}
        {desktopImage && (
          <Image
            objectFit='cover'
            {...desktopImage}
            height='100%'
            width='100%'
          />
        )}
      </div>
      <TextBanner
        placement={textBannerPlacement}
        label={label}
        buttons={buttons}
        subLabel={subLabel}
        badges={badges}
        body={body}
        hasTrustpilot={hasTrustpilot}
        textContainerAlignment={textContainerAlignment?.text}
        isVerticallyCenter={isVerticallyCenter}
      ></TextBanner>
      {shopifyPlaylist ? (
        <iframe
          className={'w-72'}
          style={{ borderRadius: '12px' }}
          src={`${shopifyPlaylist.path}`}
          width='100%'
          height='80'
          allowFullScreen={false}
          allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
          loading='lazy'
        ></iframe>
      ) : null}
    </div>
  );
};
